import { Box, Skeleton, Stack, Typography } from "@mui/material";
import CatalogSkeleton from "./CatalogSkeleton";
import FaheemMark from "./FaheemMark";

export default function DashboardLoadingShell() {
  return (
    <Box
      role="status"
      aria-label="Loading dashboard"
      sx={{ minHeight: "100dvh", bgcolor: "background.default" }}
    >
      <Box
        sx={{
          minHeight: { xs: 64, md: 72 },
          px: { xs: 2, md: 3, lg: 4 },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid",
          borderColor: "divider",
          bgcolor: "background.default",
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1.25}>
          <FaheemMark
            aria-hidden="true"
            sx={{ width: 32, height: 32, color: "primary.main" }}
          />
          <Typography
            variant="h6"
            component="span"
            fontWeight={600}
            sx={{
              display: { xs: "none", sm: "block" },
            }}
          >
            Faheem
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1}>
          <Skeleton variant="circular" width={40} height={40} />
          <Skeleton variant="circular" width={40} height={40} />
        </Stack>
      </Box>

      <Box sx={{ p: { xs: 2, md: 4 } }}>
        <Stack spacing={1.25} sx={{ maxWidth: 620, mb: 6 }}>
          <Skeleton width={82} height={20} />
          <Skeleton width="min(420px, 78vw)" height={54} />
          <Skeleton width="min(560px, 86vw)" height={28} />
        </Stack>

        <CatalogSkeleton />
      </Box>
    </Box>
  );
}
